class contentTabsV2 extends HTMLElement {
  constructor() {
    super();
    this.initialContent = document.body.innerHTML; // Store initial content
    this.currentUrl = window.location.href; // Store the initial URL
  }

  connectedCallback() {
    this.isFetchTabs = this.classList.contains('fetch-tabs');
    this.isRedirectTabs = this.classList.contains('redirect-tabs');
    this.isVisibilityTabs = this.classList.contains('visibility-tabs');
    this.initTabs();
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:load", this.initTabs.bind(this));
    }
  }

  initTabs() {
    const tabsContainer = this.querySelector(".js-custom-tabs");
    const contentTabsLinks = tabsContainer.querySelectorAll("a");
    const contentTabsSelect = this.querySelector('.content-tabs__select');
    const contentTabsSelectActive = contentTabsSelect.querySelector('.content-tabs__select-active');

    contentTabsLinks.forEach((tabLink) => {
      let isLoaded = false; // Flag to prevent duplicate loads

      const loadTabContent = (event) => {
        event.preventDefault();

        if (isLoaded) return; // Prevent running the handler again if already loaded
        isLoaded = true;

        // Tab action will change depending on the tab type.
        if (this.isPageTabs) {
          this.loadContent(tabLink).finally(() => {
            isLoaded = false;
          });
        } else if(this.isRedirectTabs) {
          this.redirectPage(tabLink);
          isLoaded = false;
        } else if(this.isVisibilityTabs) {
          this.switchTab(tabLink);
          isLoaded = false;
        }
      };

      // Attach event listeners for both 'click' and 'focus'
      tabLink.addEventListener("click", loadTabContent);
      tabLink.addEventListener("focus", loadTabContent);
    });

    // Initialize the first tab or the one specified by the URL
    const urlParams = new URLSearchParams(window.location.search);
    const tabParam = urlParams.get("tab");
    let targetTab = tabsContainer.querySelector("li.active a");

    if(!targetTab){
      targetTab = contentTabsLinks[0];
    }

    if (tabParam) {
      const tempTargetTab = tabsContainer.querySelector(`a[data-target="content-tab-${tabParam}"]`);
      if(tempTargetTab) targetTab = tempTargetTab;
    }

    if (targetTab) {
      if (this.isVisibilityTabs) targetTab.click();
      contentTabsSelectActive.textContent = targetTab.textContent;
    }

    contentTabsSelect.addEventListener('click', () => {
      tabsContainer.classList.toggle('open');
    });

    this.appendChild(contentTabsSelect);
  }

  redirectPage(tabLink) {
    const targetUrl = tabLink.getAttribute("href");
    window.location.href = targetUrl;
  }

  switchTab(tabLink) {
    const tabsContainer = this.querySelector(".js-custom-tabs");
    const contentTabSections = document.querySelectorAll(`.js-content-tab[data-tab-id^="content-tab-"]`);

    // Deactivate all tabs and content sections
    tabsContainer.querySelectorAll("li").forEach((link) => {
      link.classList.remove("active");
    });

    contentTabSections.forEach((section) => {
      section.classList.remove("active");
    });

    // Activate the clicked tab and corresponding content section
    const targetId = tabLink.getAttribute("data-target");
    const targetContent = document.querySelectorAll(`.js-content-tab[data-tab-id="${targetId}"]`);

    targetContent.forEach((section) => {
      section.classList.add("active");
    });

    tabLink.parentElement.classList.add("active");

    // Update the URL parameter
    const url = new URL(window.location);
    url.searchParams.set("tab", targetId.replace("content-tab-", ""));
  }

  loadTabContent = (event) => {
    console.log("loadTabContent");
    // Tab action will change depending on the tab type.
    if (this.isRedirectTabs) {
      // Let the browser handle the redirect naturally without preventing default behavior.
      return this.redirectPage(tabLink);
    }

    event.preventDefault();

    if (isLoaded) return; // Prevent running the handler again if already loaded
    isLoaded = true;

    if (this.isFetchTabs) {
      this.loadContent(tabLink).finally(() => {
        isLoaded = false;
      });
    } else if (this.isVisibilityTabs) {
      this.switchTab(tabLink);
      isLoaded = false;
    }
  };


}

customElements.define("content-tabs-v2", contentTabsV2);
